<template>
    <div v-show="!loading">
        <Banner />
        <LeftRightSection />
        <Info />
        <Contact />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Banner from './components/Banner.vue';
import LeftRightSection from './components/LeftRightSection.vue';
import Info from './components/Info.vue';
import Contact from './components/Contact.vue';

export default {
    components: {
        Banner,
        LeftRightSection,
        Info,
        Contact
    },
    computed: {
        ...mapState('App', ['loading']),
    },
}
</script>